import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    containerCard: {
        justifyContent: 'space-between',
        height: '100%'
    },
    stylesCard: {
        '& .rccs__name': {
            fontSize: 13
        },
        marginBottom: theme.spacing(-4)
    },
    contentCard: {
        [theme.breakpoints.down('sm')]: {
            height: '100%',
            flex: 1
        },
        '&:first-child': {
            display: 'flex',
            alignItems: 'end'
        }

    },
    contentForm: {
        padding: theme.spacing(5, 2, 2, 2) + '!important',
        backgroundColor: theme.palette.type === 'dark' ? '#4f4f4f' : '#f5f5f5',
        borderRadius: theme.shape.borderRadius
    }
}));